import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {BaseCellComponent} from '../_base-cell/base-cell.component';
import {SortTableCellUserLink} from '../../../../../shared/models/sort-table/cell-classes';
import {User} from '../../../../../shared/models/user';
import {UserLinkComponent} from '../../../user-link/user-link.component';

@Component({
  selector: 'motn-sort-table-cell-user-link',
  template: `
    <motn-user-link
      [userId]="cell.userId"
      [user]="cell.user"
      [showUsername]="true"
      [showMotionLogo]="true"
      (fetchedUser$)="fetchedUser($event)"
    ></motn-user-link>
  `,
  styleUrls: ['./sort-table-cell-user-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    UserLinkComponent,
  ],
})
export class SortTableCellUserLinkComponent extends BaseCellComponent implements OnInit {
  @Input() cell: SortTableCellUserLink;


  constructor() {
    super();
  }


  protected onInit(): void {
  }


  fetchedUser(user: User) {
    this.cell.user = user; // for sorting purposes
  }

}
